export const GetFileExtension = (fileName) => {
    return fileName.split('.').pop();
}